"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationDefinitionReferencedFrom = void 0;
/**
 * A formal computable definition of an operation (on the RESTful class) or a named query (using the search interaction).
 */
var OperationDefinitionReferencedFrom = /** @class */ (function () {
    function OperationDefinitionReferencedFrom() {
    }
    return OperationDefinitionReferencedFrom;
}());
exports.OperationDefinitionReferencedFrom = OperationDefinitionReferencedFrom;
